import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiRequestService, MAT_ICON, TOAST_STATE, ToastmessageService, HttpError, TranslationService } from '@prekog/pw-common';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { GetProductsResponse } from '../../products/getproductsresponse';
import { Material } from '../../products/material';
import { MatDialogConfig } from '@angular/material/dialog';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { Category } from '../category';
import { AddCategoryRequest } from './addcategoryrequest';
import { AddCategoryResponse } from './addcategoryresponse';
import { CreateCategoryProductRequest } from './createcategoryproductrequest';
import { CategoryProduct } from './categoryproduct';
import { CreateCategoryProductResponse } from './createcategoryproductresponse';


@Component({
    selector: 'app-addcategory',
    templateUrl: './addcategory.component.html',
    styleUrls: ['../../packages/addpackage/addpackage.component.scss']
})
export class AddcategoryComponent implements OnInit {

    storeBaseUrl = '';

    categoryForm?: FormGroup;

    category: Category = {};

    storeExistingProductsURI = '/store/get-products';

    addCategoryRequest: AddCategoryRequest = {};

    addCategoryResponse: AddCategoryResponse = {};

    addCategoryUrl = '/admin/addcategory';

    products: Material[] = [];

    filteredBooks: Material[] = [];

    categoryProductList: Material[] = [];

    createCategoryProductRequest: CreateCategoryProductRequest = {};

    createCategoryProductUrl = '/admin/createcategoryproduct';

    searchText = '';

    isExtraSmall: Observable<BreakpointState>;
    isSmall: Observable<BreakpointState>;
    isMedium: Observable<BreakpointState>;

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    constructor(
        public _router: Router,
        private _fb: FormBuilder,
        private _toastMessageService: ToastmessageService,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _translateService: TranslationService,
        private readonly breakpointObserver: BreakpointObserver
    ) {
        this.storeBaseUrl = _storeBaseUrl;
        this.createCategoryForm();
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
        this.isSmall = this.breakpointObserver.observe(Breakpoints.Small);
        this.isMedium = this.breakpointObserver.observe(Breakpoints.Medium);
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        }
        if (sessionStorage.getItem('product')) {
            const product = JSON.parse(sessionStorage.getItem('product') as string) as Material;
            const index = this.products.indexOf(product);
            this.products.splice(index, 1);
            this.categoryProductList.push(product);
            sessionStorage.removeItem('product');

        }
        this._apiRequestService.sendRequest(this.storeBaseUrl, true, {}, true, this.storeExistingProductsURI).subscribe((response) => {
            const products = response as GetProductsResponse;
            this.products = products.productList as Material[];
            this.filteredBooks = this.products;

        });
    }

    createCategoryForm() {
        this.categoryForm = this._fb.group({
            name: ['', [Validators.required]]
        });
    }

    addCategory(category: Category) {
        if (this.categoryProductList.length === 0) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.warning,
                'Kérem adjon hozzá könyveket a csomaghoz!!',
                MAT_ICON.warning
            );
            this.dismissError();
        }
        else {
            this.collectCategoryData(category);
            this.addCategoryRequest = {
                category: this.category
            };
            this._apiRequestService
                .sendRequest<AddCategoryRequest, AddCategoryResponse>(
                    this.storeBaseUrl,
                    true,
                    this.addCategoryRequest,
                    true,
                    this.addCategoryUrl
                )
                .pipe(
                    catchError((error: HttpErrorResponse) => {
                        return throwError(() => {
                            const httpError: HttpError = error.error as HttpError;

                            this._toastMessageService.displayToastMessage(
                                TOAST_STATE.error,
                                this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage),
                                MAT_ICON.error
                            );
                            this.dismissError();

                            this._router.navigateByUrl('/');
                        });
                    })
                )
                .subscribe((response) => {
                    this._toastMessageService.displayToastMessage(TOAST_STATE.success, response.responseMessage!, MAT_ICON.success);
                    this.dismissError();
                    this.category.id = response.id;

                    let categoryProductList: CategoryProduct[] = [];
                    this.categoryProductList.forEach((productsToCategory) => {
                        const categoryProduct: CategoryProduct = new CategoryProduct();
                        categoryProduct.product = productsToCategory;
                        categoryProduct.category = this.category;
                        categoryProductList.push(categoryProduct);
                    });

                    this.createCategoryProductRequest = {
                        categoryProductList: categoryProductList
                    };

                    this._apiRequestService
                        .sendRequest<CreateCategoryProductRequest, CreateCategoryProductResponse>(
                            this.storeBaseUrl,
                            true,
                            this.createCategoryProductRequest,
                            true,
                            this.createCategoryProductUrl
                        )
                        .pipe(
                            catchError((error: HttpErrorResponse) => {
                                return throwError(() => {
                                    const httpError: HttpError = error.error as HttpError;

                                    this._toastMessageService.displayToastMessage(
                                        TOAST_STATE.error,
                                        this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage),
                                        MAT_ICON.error
                                    );
                                    this.dismissError();

                                    this._router.navigateByUrl('/');
                                });
                            })
                        )
                        .subscribe((responseMessage) => {
                            this._toastMessageService.displayToastMessage(
                                TOAST_STATE.success,
                                responseMessage.responseMessage!,
                                MAT_ICON.success
                            );
                            this.dismissError();
                            this._router.navigateByUrl('/categorys');
                        });
                });
        }

    }


    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    private dismissErrorFiveSeconds(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }

    collectCategoryData(category: Category) {
        category = {
            name: this.categoryForm?.controls['name'].value as string | undefined
        };

    }

    addProductToCategory(product: Material) {

        const index = this.products.indexOf(product);
        this.products.splice(index, 1);
        this.categoryProductList.push(product);

    }

    deleteFromCategoryProductList(product: Material) {
        const index = this.categoryProductList.indexOf(product);
        this.categoryProductList.splice(index, 1);
        this.products.push(product);
    }

}
